import { apiFetch } from "../utils/apiFetch";
import { API_BASE_CLIENT as API_BASE } from "../config/vars";

export async function fetchClientCameras() {
    const res = await apiFetch(`${API_BASE}/camera-access/client/cameras`);
    if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.detail || "Не вдалося завантажити камери");
    }
    return res.json();
}

export async function fetchCameraRecordings(cameraId, limit = 72) {
    const res = await apiFetch(`${API_BASE}/camera-access/client/cameras/${encodeURIComponent(cameraId)}/recordings?limit=${encodeURIComponent(limit)}`);
    if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.detail || "Не вдалося завантажити записи камери");
    }
    return res.json();
}

export function buildCameraRecordingUrl(downloadUrl) {
    if (!downloadUrl) return "";
    if (/^https?:\/\//i.test(downloadUrl)) return downloadUrl;
    return `${API_BASE}${downloadUrl}`;
}